import React from 'react';
import { MDBDataTable, MDBPageItem, MDBPageNav, MDBPagination } from 'mdbreact';
import dayjs from 'dayjs';
import { Button } from 'reactstrap';

const columns = [
  {
    label: 'Image',
    field: 'image',
    sort: 'disabled',
    width: 150,
  },
  {
    label: 'Name',
    field: 'name',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Products',
    field: 'productsCount',
    sort: 'asc',
    width: 200,
  },
  {
    label: 'Created At',
    field: 'createdAt',
    sort: 'asc',
    width: 200,
  },
  {
    label: 'Updated At',
    field: 'updatedAt',
    sort: 'asc',
    width: 200,
  },
  {
    label: 'Actions',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const CategoriesList = (props) => {
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        searching={false}
        paging={false}
        data={{
          columns: columns,
          rows:
            props.categories &&
            props.categories.map((x) => ({
              ...x,
              name: x.name,
              image: <img src={x.image} className="rounded-circle avatar-sm card-img" />,
              productsCount: x?.khareedariProducts?.length,
              createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),
              updatedAt: dayjs(x.updateddAt).format('DD/MM/YYYY'),
              actions: (
                <Button color="info" onClick={() => props.editCategory(x)}>
                  Edit
                </Button>
              ),
            })),
        }}
      />
      <MDBPagination className="mb-5 justify-content-center">
        <MDBPageItem disabled={props?.currentPage === 1}>
          <MDBPageNav onClick={props?.handlePrev} className="page-link-custom">
            &laquo;
          </MDBPageNav>
        </MDBPageItem>
        {props?.renderPageNumbers}
        <MDBPageItem disabled={props?.currentPage === props?.pagesAmount}>
          <MDBPageNav onClick={props?.handleNext} className="page-link-custom">
            &raquo;
          </MDBPageNav>
        </MDBPageItem>
      </MDBPagination>
    </>
  );
};

export default CategoriesList;
